import {
  funilProjetadoSchema,
  listaDeFunisProjetadosSchema,
  realizadoDoAnoSchema,
  type EntradasDoAno,
  type FunilProjetado,
  type RealizadoDoAno,
} from "@base/contracts";
import { z } from "zod";
import type { ClienteHttp } from "../../../shared/http/cliente-http";

const caminho = (clienteId: string) => `/v1/clientes/${encodeURIComponent(clienteId)}`;

/** Porta de saida do Funil Projetado no front. */
export interface FunilProjetadoGateway {
  anos(clienteId: string): Promise<readonly FunilProjetado[]>;
  criarAno(clienteId: string, ano: number, copiarDe?: number): Promise<FunilProjetado>;
  salvarAno(clienteId: string, ano: number, entradas: EntradasDoAno): Promise<FunilProjetado>;
  removerAno(clienteId: string, ano: number): Promise<void>;
  realizado(clienteId: string, ano: number): Promise<RealizadoDoAno>;
}

export class FunilProjetadoGatewayHttp implements FunilProjetadoGateway {
  constructor(private readonly http: ClienteHttp) {}

  async anos(clienteId: string): Promise<readonly FunilProjetado[]> {
    return (await this.http.requisitar(`${caminho(clienteId)}/funis-projetados`, listaDeFunisProjetadosSchema)).dados;
  }

  criarAno(clienteId: string, ano: number, copiarDe?: number): Promise<FunilProjetado> {
    return this.http.requisitar(`${caminho(clienteId)}/funis-projetados`, funilProjetadoSchema, {
      metodo: "POST",
      corpo: copiarDe === undefined ? { ano } : { ano, copiarDe },
    });
  }

  salvarAno(clienteId: string, ano: number, entradas: EntradasDoAno): Promise<FunilProjetado> {
    return this.http.requisitar(`${caminho(clienteId)}/funis-projetados/${ano}`, funilProjetadoSchema, {
      metodo: "PUT",
      corpo: entradas,
    });
  }

  async removerAno(clienteId: string, ano: number): Promise<void> {
    await this.http.requisitar(`${caminho(clienteId)}/funis-projetados/${ano}`, z.null(), { metodo: "DELETE" });
  }

  realizado(clienteId: string, ano: number): Promise<RealizadoDoAno> {
    return this.http.requisitar(`${caminho(clienteId)}/dashboard/mensal`, realizadoDoAnoSchema, { consulta: { ano } });
  }
}
